import { Routes } from '../../../router';

export const ScheduleRoutes = {
  Day: `${Routes.Schedule}/${Routes.Day}`,
  Week: `${Routes.Schedule}/${Routes.Week}`,
  Month: `${Routes.Schedule}/${Routes.Month}`,
};
